import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import dayjs from 'dayjs'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import VueTour from 'vue-tour'
import Notifications from 'vue-notification'

require('vue-tour/dist/vue-tour.css')

Vue.config.productionTip = false

Vue.use(VueTour)
Vue.use(Notifications)

// Linha 38 (aproximadamente) onde começa a configuração Vuetify
Vue.use(Vuetify, {
	theme: {
		// REMOVENDO A PROPRIEDADE 'dark: true'.
		// O App.vue já lida com a inicialização do tema ($vuetify.dark),
		// eliminando o conflito com a leitura de booleano do Vuetify core.
		themes: {
			dark: {
				background: '#2D2F32',
				primary: '#40DA99',
				secondary: '#424242',
				accent: '#82B1FF',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
			},
			light: {
				background: '#F5F5F5',
				primary: '#40DA99',
				secondary: '#424242',
				accent: '#82B1FF',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
			}
		}
	},
})

Vue.use(VueClipboard)

new Vue({
	router,
	data: {
		affiliate: {},
		advertiserList: [], // <-- AQUI ESTÁ A CORREÇÃO
		selectedAdvertisers: [],
		period: {
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day')
		}
	},
	render: (h) => h(App),
}).$mount('#app')